import { render, staticRenderFns } from "./MailChimp.vue?vue&type=template&id=1b766c0a&"
import script from "./MailChimp.vue?vue&type=script&lang=js&"
export * from "./MailChimp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports